import { MutationHookOptions, useMutation } from '@apollo/client'
import {
  MarkAsUnreadConversationDocument,
  MarkAsUnreadConversationMutation,
  MarkAsUnreadConversationMutationVariables,
} from 'generated/resources/graphql'

type Options = MutationHookOptions<
  MarkAsUnreadConversationMutation,
  MarkAsUnreadConversationMutationVariables
>

export const useMarkAsUnreadConversation = (options?: Options) => {
  const [markAsUnreadConversationMutation, { loading }] = useMutation(
    MarkAsUnreadConversationDocument,
    options
  )

  return {
    loading,
    markAsUnreadConversation(variables: MarkAsUnreadConversationMutationVariables) {
      return markAsUnreadConversationMutation({
        variables,
      })
    },
  }
}
